module.exports = __webpack_public_path__ + "img/Feature-8.b2f5b1a.svg";